<template>
  <div>
    <DamagedHeader header="ดูรายละเอียดสินค้า" :img_header="header_image" link_back="stock/storage/damagedstorage"/>
    <Damaged_details/>
  </div>
</template>

<script>
import HeaderImage from '@/assets/loupe.png'
import DamagedHeader from "@/components/admin/stock/storage_damaged/header_damaged/DamagedHeader.vue";
import Damaged_details from "@/components/admin/stock/storage_damaged/Damaged_details.vue";
export default {
  name: "DamagedDetails",
  components: {
    Damaged_details,
    DamagedHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
